import * as types from './types';

const INITIAL_STATE = {
    originInput: undefined,
    destinationInput: undefined,
    originPlaceId: undefined,
    destinationPlaceId: undefined,
};

const _setOriginInput = (state, { payload }) => ({
    ...state,
    originInput: payload,
});

const _setDestinationInput = (state, { payload }) => ({
    ...state,
    destinationInput: payload,
});

const _setOriginPlaceId = (state, { payload }) => ({
    ...state,
    originPlaceId: payload,
});

const _setDestinationPlaceId = (state, { payload }) => ({
    ...state,
    destinationPlaceId: payload,
});

const handlers = {
    [types.SET_DESTINATION_INPUT]: _setDestinationInput,
    [types.SET_DESTINATION_PLACE_ID]: _setDestinationPlaceId,
    [types.SET_ORIGIN_INPUT]: _setOriginInput,
    [types.SET_ORIGIN_PLACE_ID]: _setOriginPlaceId,
};

const reducer = (state = INITIAL_STATE, action) => {
    if (handlers.hasOwnProperty(action.type)) {
        const handler = handlers[action.type];

        return handler(state, action);
    }

    return state;
};

export {
    INITIAL_STATE,
};

export default reducer;
